import React, { useState } from "react";
import { toast } from "sonner";
import { Receipt, AlertTriangle, Loader2, Check } from "lucide-react";
import { cassaBookingOrder, cassaBookingOrderAck } from "../../lib/salaApi";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Rome" });

// Cassa in Cloud external order state for a booking: open table, pending, error or orders to close by hand.
export function PosOrderBox({ b, onChanged }) {
  const [busy, setBusy] = useState(false);
  const pos = b.pos || {};
  const stale = pos.stale_orders || [];
  const canOpen = b.type === "table" && b.table && ["confirmed", "seated"].includes(b.status) && b.date === today() && !pos.order?.id;
  if (!stale.length && !pos.order?.id && !pos.order_error && !canOpen) return null;

  const run = async (fn, ok) => { setBusy(true); try { await fn(); if (ok) toast.success(ok); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "Errore cassa"); } finally { setBusy(false); } };

  return (
    <div className="mt-3 space-y-2" data-testid="sala-drawer-pos-order">
      {stale.length > 0 && (
        <div className="rounded-xl bg-amber-50 border border-amber-200 px-3 py-2 text-sm text-amber-900" data-testid="sala-pos-stale">
          <div className="flex items-start gap-2">
            <AlertTriangle className="h-4 w-4 mt-0.5 shrink-0" />
            <div className="flex-1">
              <b>Da chiudere in cassa</b>: {stale.map((s) => `tavolo ${s.table} (${s.reason})`).join(", ")}. L'API non può annullare ordini: eliminalo dall'app Cassa in Cloud.
            </div>
            <button onClick={() => run(() => cassaBookingOrderAck(b.id), "Segnato come chiuso")} disabled={busy} className="h-8 rounded-full bg-amber-600 text-white px-3 text-xs font-bold inline-flex items-center gap-1" data-testid="sala-pos-stale-ack">{busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />} Fatto</button>
          </div>
        </div>
      )}
      {pos.order?.id && (
        <div className="rounded-xl bg-sky-50 px-3 py-2 text-sm text-sky-900 inline-flex items-center gap-2" data-testid="sala-pos-order-open">
          <Receipt className="h-4 w-4" /> <span><b>Tavolo {pos.order.table} aperto in cassa</b> · {pos.order.covers} cop. · ordine inviato {String(pos.order.at || "").slice(11, 16) ? new Date(pos.order.at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" }) : ""}</span>
        </div>
      )}
      {!pos.order?.id && pos.order_error && (
        <div className="rounded-xl bg-rose-50 px-3 py-2 text-xs text-rose-800" data-testid="sala-pos-order-error">Cassa: {pos.order_error}</div>
      )}
      {canOpen && (
        <button onClick={() => run(() => cassaBookingOrder(b.id), `Tavolo ${b.table} aperto in cassa`)} disabled={busy} className="h-10 rounded-2xl border border-sky-200 bg-white text-sky-900 px-3 text-sm font-bold inline-flex items-center gap-2" data-testid="sala-pos-order-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Receipt className="h-4 w-4" />} Apri tavolo in cassa
        </button>
      )}
    </div>
  );
}
